import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import Login from './pages/Login';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Track from './pages/Track';
import About from './pages/About';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboardNew from './pages/AdminDashboardNew';
import NewShipment from './pages/NewShipment';
import EditShipment from './pages/EditShipment';
import NotFound from './pages/NotFound';
import Services from './pages/Services';
import AdminShipmentsNew from './pages/AdminShipmentsNew';
import AdminUsersNew from './pages/AdminUsersNew';
import AdminSettings from './pages/AdminSettings';
import AdminNewShipment from './pages/AdminNewShipment';
import ChatBubble from './components/ChatBubble';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/track" element={<Track />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/new-shipment" element={<NewShipment />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboardNew /></ProtectedRoute>} />
              <Route path="/admin/shipments" element={<ProtectedRoute><AdminShipmentsNew /></ProtectedRoute>} />
              <Route path="/admin/users" element={<ProtectedRoute><AdminUsersNew /></ProtectedRoute>} />
              <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
              <Route path="/admin/new" element={<ProtectedRoute><AdminNewShipment /></ProtectedRoute>} />
              <Route path="/admin/edit/:id" element={<ProtectedRoute><EditShipment /></ProtectedRoute>} />
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <ChatBubble />
    </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
